window.addEventListener("load", function () {
  // STYLES
  const head = document.head;
  const style = document.createElement("style");
  style.innerHTML = `
    .meganav-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.25);
      opacity: 0;
      transition: opacity 0.25s;
      z-index: -1
    }
    .meganav--visible--overlay .meganav-overlay {
      opacity: 1;
      z-index: 0;
    }
    .meganav--visible--overlay {
      filter: blur(8px);
      -webkit-filter: blur(8px);
    }
  `;
  head.appendChild(style);

  // FUNCTIONALITY
  const navHeader = document.querySelector(".header__wrapper");
  const mainContent = document.getElementById("MainContent");

  mainContent
    .appendChild(document.createElement("div"))
    .classList.add("meganav-overlay");

  const megaNavOverlay = document.querySelector(".meganav-overlay")

  navHeader.addEventListener("mouseover", function () {
    setTimeout(() => {
      if (navHeader.classList.contains("meganav--visible")) {
        if (!mainContent.classList.contains("meganav--visible--overlay"))
          mainContent.classList.add("meganav--visible--overlay");
      } else {
        mainContent.classList.remove("meganav--visible--overlay");
      }
    }, 300);
  });

  megaNavOverlay.addEventListener("mouseover", function() {
    mainContent.classList.remove("meganav--visible--overlay");
  })
});
